import { IPickupPoint } from "../../api/estore/checkout/interfaces/delivery-pickuppoint-interface.js";
import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { DeliveryPickupPoint } from "./delivery-pickuppoint.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";
import { el } from "../../lib/redom.es.min.js";

export class DeliveryPickupPointSelector extends BaseRedomElement {
    config: ICmsDeliverySelectorConfiguration;
    stateManager: DeliverySelectorStateManager;
    pickupPoints: IPickupPoint[] = null;
    selectedPickupPointElement: DeliveryPickupPoint;
    availablePickupPointElements: DeliveryPickupPoint[];
    optionId: string;
    elements: any;
    created: boolean = false;
    expanded: boolean;
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, stateManager: DeliverySelectorStateManager, optionId: string, pickupPoints: IPickupPoint[]) {
        super(config.useShadowRoot);
        this.config = config;
        this.root = this.config.useShadowRoot ? this.shadowRoot : this;
        this.stateManager = stateManager;
        this.optionId = optionId;
        this.pickupPoints = pickupPoints;
    }

    connectedCallback() {
        this.render();
        this.attachDelegates();
    }

    render() {
        const rel = this.element.bind(this);

        // Create pickup point elements
        this.selectedPickupPointElement = new DeliveryPickupPoint(this.config, this.stateManager, this.pickupPoints.filter(pp => pp.selected)[0]);
        this.availablePickupPointElements = this.pickupPoints.map(p => new DeliveryPickupPoint(this.config, this.stateManager, p));

        // Attack clicked handlers
        this.selectedPickupPointElement.onclick = this.expandOnClick.bind(this);

        this.availablePickupPointElements.forEach(p => {
            p.onclick = this.pickupPointClicked.bind(this);
        });
        
        const els = [
            this.config.useShadowRoot ? el("link", { rel: "stylesheet", href: this.config.cssFiles.pickupPointSelector}) : null,
            el("div.selected-container", 
                this.selectedPickupPointElement,
                el("a", { onclick: this.expandOnClick.bind(this) },
                    rel("expandSelectorImg", "img", {src: this.config.cssFiles.chevronDownIcon })
                )
            ),
            rel("pickupPointsList", "div.list-container", 
                ...this.availablePickupPointElements
            ),
            rel("selectedPickupPointDeliveryInfo", "p.selected-pickup-point-info", this.pickupPoints[0].expectedDeliveryDescription)
        ];

        this.mountArray(this.root, els);
    }

    attachDelegates() {
        const els = this.elements;

        // Selected pickup point changed
        this.stateManager.pickupPointChangedDelegates.push((optId, _, newPointId) => {
            if (this.optionId !== optId) { return; }
            
            const newPoint = this.pickupPoints.filter(p => p.id === newPointId)[0];

            if (!newPoint) { return; }

            this.selectedPickupPointElement.update(newPoint);

            els.selectedPickupPointDeliveryInfo.innerText = newPoint.expectedDeliveryDescription;
            
            for (let i = 0; i < this.availablePickupPointElements.length; i++) {
                this.availablePickupPointElements[i].update(this.pickupPoints[i]);
            }

            this.expandOnClick(null);
        });
    }

    // Event handlers
    expandOnClick(event: MouseEvent) {
        event?.preventDefault();
        event?.stopPropagation();

        const els = this.elements;

        this.expanded = !this.expanded;

        const files = this.config.cssFiles;
        els.expandSelectorImg.src = this.expanded ? files.chevronUpIcon : files.chevronDownIcon;

        const list = els.pickupPointsList as HTMLElement;
        this.expanded ? list.classList.add("visible") : list.classList.remove("visible");
    }

    pickupPointClicked(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        
        const clickedPoint = event.currentTarget as DeliveryPickupPoint;
        
        this.stateManager.setSelectedPickupPoint(this.optionId, clickedPoint.pickupPoint.id);
    }
    // #Event handlers
}

customElements.define("delivery-pickuppoint-selector", DeliveryPickupPointSelector);

